import { render, staticRenderFns } from "./PricingControlPage.vue?vue&type=template&id=821b07ba&scoped=true&lang=pug&"
import script from "./PricingControlPage.vue?vue&type=script&lang=ts&"
export * from "./PricingControlPage.vue?vue&type=script&lang=ts&"
import style0 from "./PricingControlPage.vue?vue&type=style&index=0&id=821b07ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821b07ba",
  null
  
)

export default component.exports